export default "<app-report-traveler-common [xReportType]=\"2\"></app-report-traveler-common>\r\n"